export default __webpack_public_path__ + "static/media/HomePage.60ab6844.jpg";